import request from './request'

export function listTrackingAnomaly(data) {
  return request.post('/production/tracking-anomalies/list', data)
}
export function listTrackingAnomalyByTracking(trackingId) {
  return request.get('/production/tracking-anomalies/by-tracking/' + trackingId)
}
export function getTrackingAnomaly(id) {
  return request.get('/production/tracking-anomalies/' + id)
}
export function saveTrackingAnomaly(data) {
  return request.post('/production/tracking-anomalies', data)
}
export function updateTrackingAnomaly(data) {
  return request.post('/production/tracking-anomalies/update', data)
}
export function deleteTrackingAnomaly(ids) {
  return request.post('/production/tracking-anomalies/delete', ids)
}
export function explainTrackingAnomaly(anomalyId, explanation) {
  return request.post('/production/tracking-anomalies/explain', { anomalyId, explanation })
}
export function completeTrackingAnomaly(anomalyId) {
  return request.post('/production/tracking-anomalies/complete', { anomalyId })
}
export function reworkTrackingAnomaly(anomalyId) {
  return request.post('/production/tracking-anomalies/rework', { anomalyId })
}
